import { refreshToken } from "./nimbleAPI";

let token = null;
// let refAuthID = null;
// let refreshTimer = null;


// export function setToken(newToken, minutesToExpire, newRefAuthID) {
export function setToken(newToken) {
    token = newToken;
    // refAuthID = newRefAuthID;
    // scheduleRefresh(minutesToExpire);
};

export function getToken() {
    return token;
};

// function scheduleRefresh(minutesToExpire) {
//     if (refreshTimer) clearTimeout(refreshTimer);

//     const refreshInMs = Math.max((minutesToExpire - 2) * 60 * 1000, 0);

//     refreshTimer = setTimeout(async () => {
//         const result = await refreshToken(token, refAuthID);

//         if (result) {
//             setToken(result.token, result.minutesToExpire, result.refAuthID);
//         }
//     }, refreshInMs);
// };


